module.exports = __webpack_public_path__ + "static/media/3.d07c11b1.jpg";